export default "__VITE_ASSET__BXJVGCLw__"